import { Component, ViewChild, Input, OnChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { InformesService } from 'app/services/informes.service';

interface Fechas {
  fecha_inicio: Date,
  fecha_final: Date
}

@Component({
  selector: 'app-gestion-beneficiarios-nuevos',
  templateUrl: './gestion-beneficiarios-nuevos.component.html',
  styleUrls: ['./gestion-beneficiarios-nuevos.component.scss']
})
export class GestionBeneficiariosNuevosComponent implements OnChanges, AfterViewInit, OnDestroy{

  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true})
  table: DataTableDirective
  public dtTrigger: Subject<void>

  @Input() fechas: Fechas;

  constructor(private _informe: InformesService) { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.dtOptions = {
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      columns: [
        {
          title: ''
        },
        {
          title: 'Fecha',
          data: 'fecha_inicio_contrato'
        },
        {
          title: 'Radicado',
          data: 'radicado_grupo'
        },
        {
          title: 'Cédula',
          data: 'documento_benef'
        },
        {
          title: 'Nombre',
          data: 'nombre_benef'
        },
        {
          title: 'Teléfono',
          data: 'telefono_benef'
        },
        {
          title: 'Celular',
          data: 'celular_benef'
        },
        {
          title: 'N°Servicios',
          data: 'n_beneficiarios'
        },
        {
          title: 'Nombre Titular',
          data: 'total_servicios'
        },
        {
          title: 'N°Beneficiarios',
          data: 'nombre_titular'
        },
        {
          title: 'Asesor',
          data: 'asesor'
        }
      ]
    }
  }
  
  ngOnChanges(): void {
    const FECHA_INICIAL = moment(this.fechas.fecha_inicio).format(`YYYY-MM-DD`);
    const FECHA_FINAL = moment(this.fechas.fecha_final).format(`YYYY-MM-DD`);
    
    this._informe.VerNuevosIngresosBenef(FECHA_INICIAL, FECHA_FINAL).subscribe((data: Array<Object>) => {
      this.tableOpt = data;
      this.renderer();
    });
  }

  public renderer(){
    this.table.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  

}
